/* VCTparts dashcam finder: "Welke dashcam past bij mij?" (snippets/dashcam-kiezer.liquid).
   Moved out of the snippet so the browser caches it; the shop language
   texts and collection links come from the #gdz-config JSON that the
   snippet renders. */
(function(){
  if (window.__gdzInitialized) return;
  var cfgEl = document.getElementById("gdz-config");
  if (!cfgEl) return;
  window.__gdzInitialized = true;
  /* Winkeltaal, teksten en links uit de snippet (#gdz-config) */
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent) || {}; } catch(e){ return; }

  /* -------- Vertalingen (winkeltaal via Liquid; nl = standaard) -------- */
  var I18N = CFG.i18n || {};
  function t(key, vars){
    return String(I18N[key] == null ? key : I18N[key]).replace(/%\{(\w+)\}/g, function(_, k){ return vars && vars[k] != null ? vars[k] : ""; });
  }
  /* -------- Iconen: dezelfde lijniconen als snippets/vct-icon.liquid -------- */
  var ICON_PATHS = {
    "check": '<path d="M20 6 9 17l-5-5"/>',
    "chevron-right": '<path d="m9 18 6-6-6-6"/>',
    "cart": '<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>',
    "info": '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
    "alert": '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
    "truck": '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>'
  };
  function svgIcon(name, size, cls){
    size = size || 20;
    return '<svg class="vct-icon' + (cls ? " " + cls : "") + '" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICON_PATHS[name] + '</svg>';
  }
  /* Taalprefix voor links (bijv. "/fr") en vertaalde collectie-URL's */
  var ROOT = String(CFG.root || "/").replace(/\/$/, "");
  var COLL_DASHCAMS = CFG.dashcams || "/collections/dashcams";
  var COLL_VOEDING = CFG.voeding || "/collections/dashcam-voeding";
  var COLL_TOEBEHOREN = CFG.toebehoren || "/collections/dashcam-toebehoren";

  /* -------- Vragen -------- */
  var Q_CAMS = [
    { value: "voor", label: t("q1a"), sub: t("q1aSub") },
    { value: "dual", label: t("q1b"), sub: t("q1bSub") }
  ];
  var Q_PARK = [
    { value: "ja", label: t("q2a"), sub: t("q2aSub") },
    { value: "nee", label: t("q2b"), sub: t("q2bSub") }
  ];
  var Q_BUDGET = [
    { value: "laag", label: t("q3a"), sub: t("q3aSub") },
    { value: "midden", label: t("q3b"), sub: t("q3bSub") },
    { value: "hoog", label: t("q3c"), sub: t("q3cSub") },
    { value: "alles", label: t("q3d"), sub: t("q3dSub") }
  ];
  var QUESTIONS = {
    q1: { key: "cams", title: t("q1Title"), sub: t("q1Sub"), options: Q_CAMS },
    q2: { key: "park", title: t("q2Title"), sub: t("q2Sub"), options: Q_PARK },
    q3: { key: "budget", title: t("q3Title"), sub: t("q3Sub"), options: Q_BUDGET }
  };
  function labelFor(list, v){
    for (var i = 0; i < list.length; i++) if (list[i].value === v) return list[i].label;
    return v;
  }

  var CART_ICON = svgIcon("cart", 20);

  /* -------- State -------- */
  var state = { step:"q1", cams:null, park:null, budget:null, chosen:0 };
  var camsCache = null, hwCache = null, sdCache = null;
  var renderToken = 0;
  var cartCount = 0;
  var STORAGE_KEY = "gdzPrefs";
  var STEPS = ["q1","q2","q3","result"];
  var PROGRESS = { q1:25, q2:50, q3:75, result:100 };
  var FREE_SHIPPING = 3900;

  /* -------- DOM -------- */
  var overlay = document.getElementById("gdz-overlay");
  var panel = document.getElementById("gdz-panel");
  var cartbar = document.getElementById("gdz-cartbar");
  var cartbarText = document.getElementById("gdz-cartbar-text");
  document.body.appendChild(overlay);
  document.body.appendChild(panel);
  document.body.appendChild(cartbar);
  var body = document.getElementById("gdz-body");
  var progressBar = document.getElementById("gdz-progress-bar");
  var backBtn = document.getElementById("gdz-back");
  var resetBtn = document.getElementById("gdz-reset");
  var closeBtn = document.getElementById("gdz-close");
  var openTrigger = document.getElementById("gdz-open-trigger");

  /* -------- Helpers -------- */
  function esc(s){
    return String(s == null ? "" : s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
  }
  function fmMoney(cents){ return "€" + (cents/100).toFixed(2).replace(".", ","); }
  function loadSaved(){
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (v && v.cams && v.park && v.budget) return v;
    } catch(e){}
    return null;
  }
  function saveState(){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ cams: state.cams, park: state.park, budget: state.budget })); } catch(e){}
  }
  function clearSaved(){ try { localStorage.removeItem(STORAGE_KEY); } catch(e){} }
  var t_ = t;
  function updateBannerText(){
    var t = document.getElementById("gdz-banner-title");
    var s = document.getElementById("gdz-banner-sub");
    if (!t || !s) return;
    if (loadSaved()) {
      t.textContent = t_("savedTitle");
      s.textContent = t_("savedSub");
    } else {
      t.textContent = t_("bannerTitle");
      s.textContent = t_("bannerSub");
    }
  }

  /* -------- Scroll-lock (iOS-proof) -------- */
  var scrollLockY = 0;
  function openPanel(){
    if (state.step === "q1" && !state.cams) {
      var v = loadSaved();
      if (v) { state.cams = v.cams; state.park = v.park; state.budget = v.budget; state.step = "result"; }
    }
    overlay.classList.add("is-open");
    panel.classList.add("is-open");
    scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = "fixed";
    document.body.style.top = (-scrollLockY) + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
    render();
  }
  function closePanel(){
    overlay.classList.remove("is-open");
    panel.classList.remove("is-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflow = "";
    window.scrollTo(0, scrollLockY);
  }
  function resetAll(){
    clearSaved();
    updateBannerText();
    state = { step:"q1", cams:null, park:null, budget:null, chosen:0 };
    render();
  }
  function goTo(step){ state.step = step; render(); }

  /* -------- Productdata (live uit eigen collecties) -------- */
  function fetchCollection(collUrl){
    var all = [];
    function page(p){
      return fetch(collUrl + "/products.json?limit=250&page=" + p, { headers: { "Accept": "application/json" } })
        .then(function(res){ return res.json(); })
        .then(function(data){
          var prods = (data && data.products) || [];
          all = all.concat(prods);
          if (prods.length === 250 && p < 4) return page(p + 1);
          return all;
        });
    }
    return page(1);
  }
  function normalize(p){
    var v = null;
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
    var backorder = false;
    var isAmio = /amio/i.test(p.vendor || "") || /amio/i.test(p.title || "");
    if (!v && isAmio) { v = p.variants[0]; backorder = true; } /* AMIO mag backorder */
    if (!v) return null;
    var haystack = (p.title + " " + (p.tags || []).join(" ") + " " + (p.body_html || "")).toLowerCase();
    return {
      title: p.title,
      url: ROOT + "/products/" + p.handle,
      image: (p.images && p.images[0] && p.images[0].src) || null,
      cents: Math.round(parseFloat(v.price) * 100),
      variantId: v.id,
      vendor: p.vendor || "",
      isAmio: isAmio,
      backorder: backorder,
      hasRear: /achter|rear|dual|2 camera|2-camera|3 camera|voor en achter/i.test(haystack),
      hasPark: /parkeer|parking|park mode|buffered/i.test(haystack),
      conn: detectConn(haystack)
    };
  }
  /* Aansluiting (USB-C / micro-USB / mini-USB) uit de producttekst halen,
     zodat de hardwire-kit altijd op de stekker van de dashcam past. */
  function detectConn(text){
    if (/usb[\s-]?c\b|type[\s-]?c\b/i.test(text)) return "usbc";
    if (/micro[\s-]?usb/i.test(text)) return "micro";
    if (/mini[\s-]?usb/i.test(text)) return "mini";
    return null;
  }
  var CONN_LABELS = { usbc: "USB-C", micro: "micro-USB", mini: "mini-USB" };
  function getCams(){
    if (camsCache) return Promise.resolve(camsCache);
    return fetchCollection(COLL_DASHCAMS).then(function(prods){
      camsCache = prods.map(normalize).filter(Boolean);
      return camsCache;
    });
  }
  function getHardwire(){
    if (hwCache) return Promise.resolve(hwCache);
    return fetchCollection(COLL_VOEDING).then(function(prods){
      hwCache = prods.map(normalize).filter(Boolean);
      return hwCache;
    });
  }
  function getSd(){
    if (sdCache) return Promise.resolve(sdCache);
    var url = "/search/suggest.json?q=" + encodeURIComponent(t("sdQuery")) +
      "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show";
    return fetch(url, { headers: { "Accept": "application/json" } })
      .then(function(res){ return res.json(); })
      .then(function(data){
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var match = null;
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          if (/sd[- ]?kaart|micro[- ]?sd|geheugenkaart|speicherkarte|carte m[ée]moire|memory card/i.test(p.title) && p.available) { match = p; break; }
        }
        if (!match) { sdCache = { none: true }; return sdCache; }
        var handle = (match.handle || (match.url || "").split("/products/")[1] || "").split("?")[0];
        return fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } })
          .then(function(r){ return r.json(); })
          .then(function(pj){
            var v = null;
            for (var j = 0; j < pj.variants.length; j++) { if (pj.variants[j].available) { v = pj.variants[j]; break; } }
            if (!v) { sdCache = { none: true }; return sdCache; }
            sdCache = {
              title: pj.title, url: ROOT + "/products/" + handle,
              image: pj.featured_image || null,
              cents: v.price, variantId: v.id, backorder: false
            };
            return sdCache;
          });
      })
      .catch(function(){ sdCache = { none: true }; return sdCache; });
  }
  /* Score en sorteer dashcams op basis van de antwoorden.
     AMIO heeft altijd voorrang; backorder-AMIO komt na voorradige AMIO. */
  function rankCams(cams){
    var budget = state.budget;
    function inBudget(c){
      if (budget === "laag") return c.cents <= 7500;
      if (budget === "midden") return c.cents > 7500 && c.cents <= 15000;
      if (budget === "hoog") return c.cents > 15000;
      return true;
    }
    var pool = cams.filter(function(c){
      if (state.cams === "dual" && !c.hasRear) return false;
      return true;
    });
    var budgetPool = pool.filter(inBudget);
    var relaxed = false;
    if (!budgetPool.length) { budgetPool = pool; relaxed = true; }
    budgetPool.sort(function(a, b){
      function score(c){
        var s = 0;
        if (c.isAmio && !c.backorder) s += 1000;
        if (c.isAmio && c.backorder) s += 500;
        if (state.park === "ja" && c.hasPark) s += 100;
        if (state.cams === "voor" && !c.hasRear) s += 20; /* geen onnodig duurdere dual set */
        return s;
      }
      return (score(b) - score(a)) || (b.cents - a.cents);
    });
    return { list: budgetPool.slice(0, 3), relaxed: relaxed };
  }
  /* Staffelkorting: duurste 0%, op een na duurste -5%, elk volgend -10% */
  function tierTotals(items){
    var units = [];
    items.forEach(function(it, li){ units.push({ line: li, cents: it.cents }); });
    units.sort(function(a, b){ return b.cents - a.cents; });
    var perLine = items.map(function(){ return { was: 0, now: 0, pct: 0 }; });
    var was = 0, now = 0;
    units.forEach(function(u, i){
      var d = Math.min(i * 5, 10);
      var n = Math.round(u.cents * (100 - d) / 100);
      was += u.cents; now += n;
      perLine[u.line].was += u.cents;
      perLine[u.line].now += n;
    });
    perLine.forEach(function(l){ l.pct = l.was > l.now ? Math.round((l.was - l.now) / l.was * 100) : 0; });
    return { was: was, now: now, perLine: perLine };
  }

  /* -------- Render -------- */
  function render(){
    progressBar.style.width = (PROGRESS[state.step] || 0) + "%";
    backBtn.hidden = (state.step === "q1");
    resetBtn.hidden = (state.step === "q1");
    if (QUESTIONS[state.step]) renderQuestion(state.step);
    if (state.step === "result") renderResult();
  }
  function loadingHtml(msg){
    return '<div class="gdz-loading"><div class="gdz-spinner"></div>' + (msg || t("loading")) + '</div>';
  }
  function renderQuestion(step){
    var q = QUESTIONS[step];
    body.innerHTML =
      '<span class="gdz-title">'+esc(q.title)+'</span>' +
      '<span class="gdz-sub">'+esc(q.sub)+'</span>';
    var wrap = document.createElement("div");
    wrap.className = "gdz-options";
    q.options.forEach(function(opt){
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gdz-option" + (state[q.key] === opt.value ? " is-selected" : "");
      btn.innerHTML =
        '<span style="min-width:0;"><span class="gdz-option__label">'+esc(opt.label)+'</span>' +
        (opt.sub ? '<span class="gdz-option__sub">'+esc(opt.sub)+'</span>' : '') +
        '</span><span class="gdz-option__arrow">' + (state[q.key] === opt.value ? svgIcon("check") : svgIcon("chevron-right")) + '</span>';
      btn.addEventListener("click", function(){
        state[q.key] = opt.value;
        state.chosen = 0;
        var idx = STEPS.indexOf(step);
        setTimeout(function(){ goTo(STEPS[idx + 1]); }, 150);
        render();
      });
      wrap.appendChild(btn);
    });
    body.appendChild(wrap);
  }

  function renderResult(){
    saveState();
    updateBannerText();
    body.innerHTML =
      '<span class="gdz-title">' + t("resultTitle") + '</span>' +
      '<span class="gdz-sub">' + t("resultSub") + '</span>';
    var chips = document.createElement("div");
    chips.className = "gdz-chips";
    [["q1", labelFor(Q_CAMS, state.cams)], ["q2", state.park === "ja" ? t("parkYes") : t("parkNo")], ["q3", labelFor(Q_BUDGET, state.budget)]].forEach(function(pair){
      var chip = document.createElement("button");
      chip.type = "button";
      chip.className = "gdz-chip";
      chip.innerHTML = svgIcon("check", 16) + "<b>"+esc(pair[1])+"</b>";
      chip.addEventListener("click", function(){ goTo(pair[0]); });
      chips.appendChild(chip);
    });
    body.appendChild(chips);
    var slot = document.createElement("div");
    slot.innerHTML = loadingHtml(t("comparing"));
    body.appendChild(slot);
    var token = ++renderToken;
    Promise.all([getCams(), getHardwire(), getSd()]).then(function(res){
      if (token !== renderToken || state.step !== "result") return;
      var ranked = rankCams(res[0]);
      var cams = ranked.list;
      var hardwires = res[1];
      var sd = res[2];
      slot.innerHTML = "";
      if (!cams.length) {
        slot.innerHTML = '<div class="gdz-error">' + svgIcon("info", 18) + '<span>' + t("noCam") + '</span></div>';
      } else {
        if (state.chosen >= cams.length) state.chosen = 0;
        if (ranked.relaxed) {
          slot.innerHTML += '<div class="gdz-error">' + svgIcon("info", 18) + '<span>' + t("relaxed") + '</span></div>';
        }
        var label = document.createElement("div");
        label.className = "gdz-sectionlabel";
        label.textContent = t("pickCam");
        slot.appendChild(label);
        var camWrap = document.createElement("div");
        slot.appendChild(camWrap);
        var setWrap = document.createElement("div");
        slot.appendChild(setWrap);
        function renderCams(){
          camWrap.innerHTML = "";
          cams.forEach(function(c, i){
            var card = document.createElement("button");
            card.type = "button";
            card.className = "gdz-cam" + (state.chosen === i ? " is-selected" : "");
            card.setAttribute("aria-pressed", state.chosen === i ? "true" : "false");
            card.innerHTML =
              (i === 0 ? '<span class="gdz-cam__badge">' + t("bestMatch") + '</span>' : '') +
              '<span class="gdz-cam__img">' + (c.image ? '<img src="'+c.image+'" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="gdz-cam__body">' +
                '<span class="gdz-cam__title">'+esc(c.title)+'</span>' +
                '<span class="gdz-cam__prices">' +
                  '<span class="gdz-cam__price">'+fmMoney(c.cents)+'</span>' +
                  (c.backorder ? '<span class="gdz-tag gdz-tag--backorder">' + esc(t("backorder")) + '</span>' : '') +
                '</span>' +
                '<span class="gdz-cam__pick">'+(state.chosen === i ? svgIcon("check", 16) + '<span>' + t("selected") + '</span>' : t("selectThis"))+'</span>' +
              '</span>';
            card.addEventListener("click", function(){
              state.chosen = i;
              renderCams();
              renderSet();
            });
            camWrap.appendChild(card);
          });
        }
        /* -------- Complete set -------- */
        var items = [];
        var hwMissing = false;
        var hwMissingConn = null;
        function buildItems(){
          var cam = cams[state.chosen];
          items = [{ pos: t("posDashcam"), product: cam, checked: true, locked: true }];
          hwMissing = false;
          if (state.park === "ja") {
            /* Alleen ECHTE hardwire-kits/parkeermodus-kabels; de collectie
               bevat ook signaalfilters en adapters, die horen hier niet. */
            var HW_RE = /hardwire|parkeermodus|continue voeding/i;
            var HW_EXCL = /signaal|filter|interferentie|verloop|iso radio|netstroom|splitter/i;
            var kits = hardwires.filter(function(h){
              return HW_RE.test(h.title) && !HW_EXCL.test(h.title) && !h.backorder;
            });
            /* Aansluiting moet passen: een USB-C dashcam krijgt nooit een
               mini/micro-USB kabel geadviseerd. */
            var camConn = cam.conn;
            var note;
            if (camConn) {
              kits = kits.filter(function(k){ return k.conn === camConn; });
              note = t("hwFits", { conn: CONN_LABELS[camConn] });
            } else {
              note = t("hwCheck");
            }
            /* Voorkeur: zelfde merk als de camera (bv. AZDome kit bij
               AZDome cam), anders de universele */
            var hw = null;
            var camBrand = (cam.vendor || "").toLowerCase();
            for (var i = 0; i < kits.length; i++) {
              if (camBrand && (kits[i].vendor || "").toLowerCase() === camBrand) { hw = kits[i]; break; }
            }
            if (!hw && kits.length) hw = kits[0];
            if (hw) {
              items.push({ pos: t("posHw"), product: hw, checked: true, note: note });
            } else {
              hwMissing = true;
              hwMissingConn = camConn ? CONN_LABELS[camConn] : null;
            }
          }
          if (sd && !sd.none) {
            items.push({ pos: t("posSd"), product: sd, checked: true });
          }
        }
        function renderSet(){
          buildItemsIfNeeded();
          var sel = items.filter(function(it){ return it.checked; });
          var totals = tierTotals(sel.map(function(it){ return { cents: it.product.cents }; }));
          var lineInfo = {};
          sel.forEach(function(it, si){ lineInfo[items.indexOf(it)] = totals.perLine[si]; });
          var anyBackorder = sel.some(function(it){ return it.product.backorder; });
          var rows = items.map(function(it, idx){
            var p = it.product;
            var li = it.checked ? lineInfo[idx] : null;
            var priceHtml;
            if (li && li.pct > 0) {
              priceHtml = '<span class="gdz-set__price">'+fmMoney(li.now)+'</span>' +
                '<span class="gdz-set__was">'+fmMoney(li.was)+'</span>' +
                '<span class="gdz-disc">-'+li.pct+'%</span>';
            } else {
              priceHtml = '<span class="gdz-set__price">'+fmMoney(p.cents)+'</span>';
            }
            return '<div class="gdz-set__item'+(it.checked ? ' is-checked' : '')+'" data-idx="'+idx+'">' +
              '<span class="gdz-set__check">'+(it.checked ? svgIcon("check", 16) : '')+'</span>' +
              '<div class="gdz-set__img">'+(p.image ? '<img src="'+p.image+'" alt="" loading="lazy">' : '')+'</div>' +
              '<div class="gdz-set__info">' +
                '<span class="gdz-set__pos">'+esc(it.pos)+'</span>' +
                '<a class="gdz-set__name" href="'+p.url+'">'+esc(p.title)+'</a>' +
                '<span class="gdz-set__prices">' + priceHtml +
                  (p.backorder ? '<span class="gdz-tag gdz-tag--backorder">' + esc(t("backorder")) + '</span>' : '') +
                '</span>' +
                (it.note ? '<span class="gdz-set__pos" style="text-transform:none;letter-spacing:0;font-weight:600;">'+esc(it.note)+'</span>' : '') +
              '</div>' +
            '</div>';
          }).join("");
          var hwMissingHtml = hwMissing
            ? '<div class="gdz-set__item is-missing"><div class="gdz-set__info">' +
              '<span class="gdz-set__pos">' + esc(t("posHwShort")) + (hwMissingConn ? ' (' + esc(hwMissingConn) + ')' : '') + '</span>' +
              '<span class="gdz-set__name">' + (hwMissingConn
                ? t("hwMissingConn", { conn: esc(hwMissingConn) })
                : t("hwMissing")) + '</span>' +
              '</div></div>'
            : "";
          var sdMissing = (!sd || sd.none)
            ? '<div class="gdz-set__item is-missing"><div class="gdz-set__info">' +
              '<span class="gdz-set__pos">' + esc(t("posSd")) + '</span>' +
              '<span class="gdz-set__name">' + t("sdMissing") + '</span>' +
              '</div></div>'
            : "";
          var discPct = totals.was > totals.now ? Math.round((totals.was - totals.now) / totals.was * 100) : 0;
          var totalHtml =
            '<span>' + (sel.length === 1 ? t("totalOne") : t("totalMany", { n: sel.length })) + '</span>' +
            '<span class="gdz-set__totalprices">' +
              (discPct > 0 ? '<span class="gdz-set__totalwas">'+fmMoney(totals.was)+'</span>' : '') +
              '<span>'+fmMoney(totals.now)+'</span>' +
              (discPct > 0 ? '<span class="gdz-disc">-'+discPct+'%</span>' : '') +
            '</span>';
          var shipHtml = "";
          if (totals.now >= FREE_SHIPPING && totals.now > 0) {
            shipHtml = '<div class="gdz-set__shipping"><p class="gdz-set__shiptext is-free">' + svgIcon("check", 16) + '<span>' + t("freeShipping") + '</span></p><div class="gdz-set__shipbar"><span class="is-free" style="width:100%"></span></div></div>';
          } else if (totals.now > 0) {
            shipHtml = '<div class="gdz-set__shipping"><p class="gdz-set__shiptext">' + svgIcon("truck", 16) + '<span>' + t("untilFree", { amount: fmMoney(FREE_SHIPPING - totals.now) }) + '</span></p><div class="gdz-set__shipbar"><span style="width:'+Math.round(totals.now / FREE_SHIPPING * 100)+'%"></span></div></div>';
          }
          var backorderHtml = anyBackorder
            ? '<div class="gdz-set__notice">' + svgIcon("info", 18) + '<span>' + t("backorderNotice") + '</span></div>'
            : "";
          setWrap.innerHTML = "";
          var box = document.createElement("div");
          box.className = "gdz-set";
          box.innerHTML =
            '<span class="gdz-set__badge">' + t("badge") + '</span>' +
            '<span class="gdz-set__title">' + t("setTitle") + '</span>' +
            '<div class="gdz-set__items">'+rows+hwMissingHtml+sdMissing+'</div>' +
            '<div class="gdz-set__total">'+totalHtml+'</div>' +
            shipHtml +
            backorderHtml +
            '<button type="button" class="gdz-set__addbtn"'+(sel.length ? '' : ' disabled')+'>' +
              (sel.length ? CART_ICON + '<span>' + (sel.length === 1 ? t("addOne") : t("addMany", { n: sel.length })) + '</span>' : '<span>' + t("selectMin") + '</span>') +
            '</button>' +
            '<span class="gdz-set__fineprint">' + t("fineprint") + '</span>';
          setWrap.appendChild(box);
          box.querySelectorAll(".gdz-set__item[data-idx]").forEach(function(row){
            row.addEventListener("click", function(e){
              if (e.target.closest("a")) return;
              var idx = parseInt(row.getAttribute("data-idx"), 10);
              if (items[idx].locked) return; /* de dashcam zelf wissel je via de kaarten */
              items[idx].checked = !items[idx].checked;
              renderSet();
            });
          });
          var addBtn = box.querySelector(".gdz-set__addbtn");
          if (sel.length) {
            addBtn.addEventListener("click", function(){
              var lines = sel.map(function(it){ return { id: it.product.variantId, quantity: 1 }; });
              addToCart(lines, addBtn, sel.length);
            });
          }
        }
        var lastChosen = -1;
        function buildItemsIfNeeded(){
          if (lastChosen !== state.chosen) { buildItems(); lastChosen = state.chosen; }
        }
        renderCams();
        renderSet();
      }
      var actions = document.createElement("div");
      actions.className = "gdz-footeractions";
      actions.innerHTML =
        '<a href="' + COLL_TOEBEHOREN + '" class="gdz-btn gdz-btn--ghost" style="text-decoration:none !important;">' + t("allDashcams") + '</a>' +
        '<button type="button" class="gdz-btn gdz-btn--ghost" id="gdz-again">' + t("otherChoices") + '</button>';
      slot.appendChild(actions);
      actions.querySelector("#gdz-again").addEventListener("click", function(){ goTo("q1"); });
    }).catch(function(){
      if (token === renderToken) slot.innerHTML = '<div class="gdz-error">' + svgIcon("alert", 18) + '<span>' + t("loadError") + '</span></div>';
    });
  }

  /* ---- Live cart-update (zelfde gelaagde aanpak als de andere kiezers) ---- */
  function getThemeCartEl(){
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }
  function updateCartCounters(itemCount){
    [".cart-count-bubble span[aria-hidden]", ".cart-count-bubble", "[data-cart-count]", ".cart-count", "#CartCount", ".cart-link__bubble-num", ".site-header__cart-count span", ".cart_count", ".cartCount"].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if (el.hasAttribute("data-cart-count")) el.setAttribute("data-cart-count", itemCount);
        if (/^\s*\d+\s*$/.test(el.textContent)) el.textContent = itemCount;
      });
    });
  }
  function notifyThemeCartUpdated(cartData){
    ["cart:refresh","cart:updated","cart:change","cart:build","ajaxProduct:added"].forEach(function(name){
      try { document.dispatchEvent(new CustomEvent(name, { bubbles:true, detail:{ cart: cartData } })); } catch(e){}
    });
    try {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "dashcam-kiezer", cartData: cartData });
      }
    } catch(e){}
    try { if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") window.Shopify.onCartUpdate(cartData); } catch(e){}
    /* Dit theme: ajaxCart vult de side-cart (aside#cart) en luistert naar "listCart" */
    try { if (window.ajaxCart && typeof window.ajaxCart.load === "function") window.ajaxCart.load(); } catch(e){}
    try { window.dispatchEvent(new CustomEvent("listCart")); } catch(e){}
  }
  function refreshThemeCart(){
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(res){ return res.json(); })
      .then(function(cart){ updateCartCounters(cart.item_count); notifyThemeCartUpdated(cart); })
      .catch(function(){});
  }
  var kiezerAttrSet = false;
  function markKiezerOrder(){
    if (kiezerAttrSet) return;
    kiezerAttrSet = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: { "Dashcam Kiezer": "ja" } })
    }).catch(function(){ kiezerAttrSet = false; });
  }
  function addToCart(lines, btn, count){
    if (!lines || !lines.length) return;
    btn.disabled = true;
    var originalHtml = btn.innerHTML;
    btn.innerHTML = "<span>" + t("adding") + "</span>";
    var cartEl = getThemeCartEl();
    var payload = { items: lines };
    if (cartEl && typeof cartEl.renderContents === "function" && typeof cartEl.getSectionsToRender === "function") {
      try {
        payload.sections = cartEl.getSectionsToRender().map(function(s){ return s.id; });
        payload.sections_url = window.location.pathname;
      } catch(e){}
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function(res){
      if (!res.ok) throw new Error("cart add failed");
      return res.json();
    }).then(function(response){
      cartCount += count;
      btn.innerHTML = svgIcon("check", 20, "gdz-icon-added") + "<span>" + t("addedCheck") + "</span>";
      cartbarText.textContent = t("addedCount", { n: cartCount });
      cartbar.classList.add("is-visible");
      clearTimeout(addToCart._t);
      addToCart._t = setTimeout(function(){ cartbar.classList.remove("is-visible"); }, 4000);
      markKiezerOrder();
      if (cartEl && typeof cartEl.renderContents === "function" && response.sections) {
        try { cartEl.renderContents(response); } catch(e){}
        try { if (typeof cartEl.close === "function") setTimeout(function(){ cartEl.close(); }, 50); } catch(e){}
      }
      refreshThemeCart();
      setTimeout(function(){ btn.innerHTML = originalHtml; btn.disabled = false; }, 1600);
    }).catch(function(){
      btn.innerHTML = "<span>" + t("addFailed") + "</span>";
      btn.disabled = false;
    });
  }

  /* -------- Grid-plaatsing (na 4e product; schuift op als er al andere
     kiezers in de grid staan) -------- */
  function placeInGrid(){
    var grid = document.getElementById("collection");
    if (!grid || !openTrigger || openTrigger.closest(".gdz-grid-slot")) return;
    var slot = document.createElement("li");
    slot.className = "gdz-grid-slot";
    var children = Array.prototype.slice.call(grid.children);
    var otherSlots = grid.querySelectorAll(".gpf-grid-slot, .gfz-grid-slot").length;
    var target = 4 + otherSlots * 4;
    var productCount = 0, anchor = null;
    for (var i = 0; i < children.length; i++) {
      if (/gpf-grid-slot|gfz-grid-slot|gdz-grid-slot/.test(children[i].className)) continue;
      productCount++;
      if (productCount === target) { anchor = children[i]; break; }
    }
    if (anchor) { anchor.insertAdjacentElement("afterend", slot); } else { grid.appendChild(slot); }
    slot.appendChild(openTrigger);
  }
  function initGridPlacement(){
    setTimeout(function(){
      placeInGrid();
      openTrigger.classList.remove("gdz-pending");
    }, 120);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGridPlacement);
  } else {
    initGridPlacement();
  }

  /* -------- Events -------- */
  openTrigger.addEventListener("click", openPanel);
  openTrigger.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openPanel(); } });
  closeBtn.addEventListener("click", closePanel);
  overlay.addEventListener("click", closePanel);
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") closePanel(); });
  resetBtn.addEventListener("click", resetAll);
  backBtn.addEventListener("click", function(){
    var idx = STEPS.indexOf(state.step);
    if (idx > 0) goTo(STEPS[idx - 1]);
  });

  updateBannerText();
})();
